module.exports = __webpack_public_path__ + "img/ThumbsDownIcon.cdb07191.svg";